module.exports = __webpack_public_path__ + "static/media/mem5YaGs126MiZpBA-UNirkOX-hpOqc.76563ea1.woff2";